// extracted by mini-css-extract-plugin
export default {"toolContainer":"Tool_toolContainer__1DTnH","toolHeader":"Tool_toolHeader__at968"};